export default "__VITE_ASSET__DB$Zh2Lh__"